<script context="module">
    import { getContext } from 'svelte'
    const MENU_CONTEXT = {}
    export function getMenuContext() {
        return getContext(MENU_CONTEXT)
    } 
</script>
<script lang="typescript">
    import { createEventDispatcher, setContext } from 'svelte'
    import { fade } from 'svelte/transition'
    import ModalPanel from './ModalPanel.svelte'

    setContext(MENU_CONTEXT, {
        itemSelected: () => {
            onClose();
        }
    })

    const dispatch = createEventDispatcher();
    function onClose() {
        dispatch("close")
    }
</script>

<ModalPanel on:wantClose={() => onClose()} style="top: 3.1rem; right: 0.25rem;"  backgroundStyle="background-color: initial;">
    <ul>
        <slot></slot>
    </ul>
</ModalPanel>


<style>
    ul {
		padding: 0;
		list-style: none;
		margin: 0;
	}
</style>

